import React from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-remarkable';
import {shelfGemTypes}  from 'helpers/constants';

const biolabShelfInternalDomainRegex = '(<a href=\\")(http://|https://){1}(biolab.shelf.io/read/)';

let ArticleContents = ({article, formatMessage, disableFooter = false, urlContext = 'encyclopedia', hideArticleTitle = false}) => {
  article = article || {};

  article.body = !!article.body ? article.body.replace(new RegExp(biolabShelfInternalDomainRegex, 'g'), `<a href=\"#${urlContext}/`) : article.body;

  const previewMedia = article.url && article.type && [shelfGemTypes.audio, shelfGemTypes.video, shelfGemTypes.image].includes(article.type);

  const externalProviderVideo = shelfGemTypes.video === article.type && !article.enableContentDownload;

  if(externalProviderVideo) {
    if(article.url.includes('youtube.com/watch')) {
      article.url = article.url.replace('youtube.com/watch?v=', 'youtube.com/embed/');
    } else if(article.url.includes('vimeo.com/') && !article.url.includes('player.vimeo.com/')) {
      article.url = article.url.replace('vimeo.com/', 'player.vimeo.com/video/');
    }
  }

  return (
    <div className='article-contents'>
      <Markdown options={{html: true}}>
        {!hideArticleTitle ?
          <h1 className='article-header'>
            {article.title}
            {article.url && !article.enablePDFPreview ? <a className='article-header__link btn btn-primary pull-right' target="_blank" href={article.url}>
              {formatMessage({id: article.enableContentDownload ? 'general.download' : 'general.open'})}
            </a> : null}
          </h1> :
        null}
        {article.url && shelfGemTypes.link === article.type && article.description ?
          <p className="article-description">{article.description}</p> :
        null}
        {article.body || null}
        {article.url && article.enablePDFPreview ? <iframe src={article.url} scrolling="auto" height="1100" width="850" ></iframe> : null}
        {previewMedia && shelfGemTypes.audio === article.type ?
          <audio controls style={{width: '100%'}}>
            <source src={article.url} type="audio/mpeg"/>
            {formatMessage({id: 'encyclopedia.audio.unsupported'})}
          </audio> : null}
        {previewMedia && shelfGemTypes.image === article.type ?
          <img className="img-responsive center-block" width="50%" height="auto" src={article.url}></img> : null}
        {previewMedia && shelfGemTypes.video === article.type ?
         externalProviderVideo ?
           <iframe src={article.url} width="100%" height="480" frameBorder="0" webkitallowfullscreen mozallowfullscreen allowFullScreen></iframe> :
           <video width="100%" controls preload="auto">
             <source  src={article.url}  type="video/mp4"/>
             {formatMessage({id: 'encyclopedia.video.unsupported'})}
           </video> : null}
        {!disableFooter ?
          <div className='article-footer'>
            <p>
              {formatMessage({id: 'encyclopedia.description'})}
            </p>
          </div> : null}
      </Markdown>
    </div>
  );
};

ArticleContents.propTypes = {
  article: PropTypes.object,
  disableFooter: PropTypes.bool,
  urlContext: PropTypes.string,
  hideArticleTitle: PropTypes.bool,
  formatMessage: PropTypes.func.isRequired,
  disableFooter: PropTypes.bool,
  urlContext: PropTypes.string,
  hideArticleTitle: PropTypes.bool,
};

export default ArticleContents;
